import React, { Component, Fragment } from 'react'
import { Trans } from '@lingui/macro'
import { connect } from 'react-redux'

import NotificationStep from '../../../components/NotificationStep/'
import Row from '../../../components/Row/'
import { Typography } from 'components'

import * as actions from '../../../redux/actions'
import * as routes from './../../../settings/_routesSettings'
import { history } from '../../../routers/AppRouter'
import { configMixpanelCookieExpiration } from 'settings/mixpanel'

class Response extends Component {

  state = {
    sucess: true,
    buttonId: 'to-cart',
    btnText: 'TENTE NOVAMENTE',
    mainText: (<div></div>),
    onSuccessClick: () => history.push(routes.PAYMENT_CART),
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps !== this.props) {
      this.formatNotification()
    }
  }

  componentDidMount = () => {
    this.formatNotification()
  }

  handleMixpanelCookieExpiration() {
    const EXPIRATION_IN_DAYS = 1
    
    return configMixpanelCookieExpiration(EXPIRATION_IN_DAYS)
  }

  formatNotification = () => {
    let formatState = {}
    //THE CREDIT CARD DATA IS WRONG
    if (this.props.cardRegisterSuccess === false) {
      formatState.sucess = false
      formatState.mainText = this.badCardEntry()
      this.setState({ ...formatState })
      return
    }
    //THE CREDIT CARD DATA IS OK
    //OVERBOOKING
    if (this.props.overbooking === true && this.props.paymentConfirmed !== true && this.props.paymentSucess !== true) {
      formatState.sucess = false
      formatState.mainText = this.overbooking()
      formatState.btnText = 'ESCOLHER NOVAMENTE'
      formatState.onSuccessClick = () => history.push(routes.PROFESSIONAL_PSIC_PROFILE(this.props.professionalFriendlyUrl))
    }
    //PAYMENT CONFIRMED
    else if (this.props.paymentConfirmed === true && this.props.paymentSucess === true) {
      this.handleMixpanelCookieExpiration()
      formatState.sucess = true
      formatState.mainText = this.successPayment()
      formatState.btnText = 'VER MINHAS CONSULTAS'
      formatState.onSuccessClick = () => history.push(routes.DASHBOARD_APPOINTMENTS)
      formatState.buttonId = 'to-appointments'
    }
    //PAYMENT RECUSED
    else if (this.props.paymentConfirmed === true && this.props.paymentSucess === false) {
      formatState.sucess = false
      formatState.mainText = this.rejectedPayment()
    }
    //WAITING PAYMENT
    else {
      formatState.sucess = true
      formatState.mainText = this.waitingPayment()
      formatState.btnText = 'VER MINHAS CONSULTAS'
      formatState.onSuccessClick = () => history.push(routes.DASHBOARD_APPOINTMENTS)
      formatState.buttonId = 'to-appointments'
    }

    this.setState({ ...formatState })

  }

  badCardEntry = () => (
    <Fragment>
      <Row margin="1.5rem 0 0 0">
        <Typography
          align="center">
          <Trans>
            Ops, algum dado foi digitado incorretamente, verifique os campos preenchidos.
          </Trans>
        </Typography>
      </Row>
    </Fragment>
  )

  waitingPayment = () => (
    <Fragment>
      <Row margin="1.5rem 0 0 0">
        <Typography
          align="center">
          {/* Seu pedido foi registrado com sucesso, no entanto o pagamento ainda está sendo processado. Aguarde um e-mail com mais detalhes. */}
          <Trans>
            Seu pedido foi registrado com sucesso, no entanto o pagamento ainda está sendo processado. Aguarde um e-mail com mais detalhes.
          </Trans>
        </Typography>
      </Row>
      <Row margin="1.5rem 0 0 0"
        align="center"
        justify="center">
        <Typography bold
          align="center">
          <Trans>
            Nº do pedido:
          </Trans>
          {this.props.orderId}
        </Typography>
      </Row>
    </Fragment>
  )

  successPayment = () => (
    <Fragment>
      <Row margin="1.5rem 0 0 0">
        <Typography
          align="center">
          {/* Seu pagamento foi efetuado com sucesso ou está em processamento!<br/>Verifique seu e-mail para mais detalhes. */}
          <Trans>
            Seu pagamento foi efetuado com sucesso! Verifique seu e-mail para mais detalhes.
          </Trans>
        </Typography>
      </Row>
      <Row margin="1.5rem 0 0 0"
        align="center"
        justify="center">
        <Typography bold
          align="center">
          <Trans>
            Nº do pedido:
          </Trans>
          {this.props.orderId}
        </Typography>
      </Row>
    </Fragment>
  )

  rejectedPayment = () => (
    <Fragment>
      <Row margin="1.5rem 0 0 0">
        <Typography
          align="center">
          <Trans>
            Seu pagamento foi recusado, entre em contato com a operadora do seu cartão para maiores informações.
          </Trans>
        </Typography>
      </Row>
    </Fragment>
  )

  overbooking = () => (
    <Fragment>
      <Row margin="1.5rem 0 0 0">
        <Typography
          align="center">
          <Trans>
            Infelizmente um ou mais horários escolhidos ficaram indisponíveis. Por favor, escolha um novo horário e tente novamente.
          </Trans>
        </Typography>
      </Row>
    </Fragment>
  )

  render() {
    return (
      <div className="Response">
        <Row justify="center"
          margin="7rem 0 0">
          <NotificationStep buttonId={this.state.buttonId}
            btnText={this.state.btnText}
            iconName={this.state.sucess ? 'OutlineCheck' : 'ErrorIcon'}
            iconColor={this.state.sucess ? '#01dfcd' : '#ff4949'}
            mainText={(
              <div className="Response__container">
                {this.state.mainText}
              </div>
            )}
            onSuccessClick={() => {
              this.props.onClearPayment()
              this.state.onSuccessClick()
            }}
          />
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    orderId: state.orders.id,
    cardRegisterSuccess: state.payment.cardRegisterSuccess,
    paymentSucess: state.payment.paymentSucess,
    paymentConfirmed: state.payment.paymentConfirmed,
    overbooking: state.payment.overbooking,
    professionalFriendlyUrl: state.orders.professionalFriendlyUrl
  }
}

const mapDispatchToProps = dispatch => {
  return { 
    onGetOrders: (id) => dispatch(actions.getOrders(id)), //TODO: Adicionar orderID como parâmetro
    onClearPayment: () => dispatch(actions.clearPayment())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Response)